<template>
  <div class="mb-5 mt-4 flex justify-center">
    <img
      src="@/assets/edge-capacity.svg"
      alt="edge capacity logo"
    />
  </div>
  <div class="my-4 mb-4 w-full border-t border-light-gray md:border-none" />
  <layout>
    <div>
      <div class="mb-1 flex content-center">
        <h1 class="self-start py-1 text-left text-2xl text-dark-gray">
          Onboarding Complete!
        </h1>
      </div>
      <section>
        <p class="my-5 text-left text-dark-gray">
          You have successfully onboarded {{ carrierName }} with this broker.
        </p>
        <p class="mb-5 text-left text-dark-gray">
          You can add more Carriers in your Dispatch Service Portal.
        </p>
        <button-main
          class="mb-4 flex flex-row items-center justify-center"
          @click="handleSubmit"
        >
          Go to Dispatch Service Portal
          <img
            class="ml-1 h-5 w-5"
            src="@/assets/launch-icon.svg"
            alt="launch-icon"
          />
        </button-main>
      </section>
    </div>
  </layout>
</template>

<script>
import Layout from '@/components/LoginLayout.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'OnboardingComplete',
  components: {
    Layout,
    ButtonMain,
  },
  computed: {
    carrierName() {
      return this.$store.state.carriers?.carrierDetails?.legal_name || '';
    },
  },
  methods: {
    handleSubmit() {
      // TODO - Related to a new product which is building.
    },
  },
};
</script>
